import type { TOC } from '@ember/component/template-only'
import { LinkTo } from '@ember/routing'
import { t } from 'ember-intl'
import { gt } from 'ember-truth-helpers'
import { CollectionCardHeader } from 'teacher-ui-client/components/book-library/collection-card/header'
import { CollectionCardBody } from 'teacher-ui-client/components/book-library/collection-card/body'
import { CollectionCardFooter } from 'teacher-ui-client/components/book-library/collection-card/footer'
import type BookLibraryCollection from 'teacher-ui-client/models/book-library/collection'

interface Signature {
  Element: HTMLDivElement
  Args: { bookCollection: BookLibraryCollection; deleteCollectionAction: () => void }
}

export const BookLibraryCollectionCard: TOC<Signature> = <template>
  <div class="inline-block" ...attributes>
    <CollectionCardHeader
      class="my-1 py-1"
      @collectionId={{@bookCollection.id}}
      @showShareLink={{gt @bookCollection.count 0}}
      @deleteCollectionAction={{@deleteCollectionAction}}
      @isFavourite={{@bookCollection.isFavourite}}
    />
    <LinkTo
      aria-label={{t "bookLibrary.components.card.viewBookDetail"}}
      @route="subscription-type.book-library.collection.show"
      @model={{@bookCollection.id}}
    >
      <CollectionCardBody
        @previewImg={{@bookCollection.collectionPreviewImg}}
        @fullImg={{@bookCollection.collectionFullImg}}
        @bookCoverAlt={{@bookCollection.name}}
        @isFavourite={{@bookCollection.isFavourite}}
      />
      <CollectionCardFooter
        class="flex flex-col items-center"
        @name={{@bookCollection.name}}
        @bookCount={{@bookCollection.count}}
        @isFavourite={{@bookCollection.isFavourite}}
      />
    </LinkTo>
  </div>
</template>

export default BookLibraryCollectionCard
